module.exports = __webpack_public_path__ + "play-pause.svg";


//////////////////
// WEBPACK FOOTER
// ./~/blueimp-gallery/img/play-pause.svg
// module id = 1142
// module chunks = 14